import React from "react";

export default function WeatherFooter() {
  return (
    <footer>
      This project was coded by Polina Tretiakova and{" "}
      <a
        href="https://github.com/PollyT249/react-weather-app"
        target="_blank"
        rel="noreferrer"
      >
        open-sourced on GitHub
      </a>
    </footer>
  );
}
